import { render, staticRenderFns } from "./colorKey.vue?vue&type=template&id=7861bbd8&scoped=true"
import script from "./colorKey.vue?vue&type=script&lang=js"
export * from "./colorKey.vue?vue&type=script&lang=js"
import style0 from "./colorKey.vue?vue&type=style&index=0&id=7861bbd8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7861bbd8",
  null
  
)

export default component.exports